











import { Component } from 'vue-property-decorator'
import { AbstractModuleUi } from '../../abstract/ui'
import { IframeModule } from '../Iframe.contracts'

@Component<IframeModuleUi>({
  name: 'IframeModuleUi'
})
export class IframeModuleUi extends AbstractModuleUi<IframeModule> {
  public get hasContent (): boolean {
    return typeof this.data.content.src === 'string' && this.data.content.src.length > 0
  }
}

export default IframeModuleUi
